import React, { useState, useEffect, useCallback } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import {
  Tabs,
  Tab,
  Tooltip,
  Button,
  OverlayTrigger,
  Modal,
  Dropdown,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useLocation } from "react-router-dom";
import { getInvoiceBusinessUnitList } from "../../../service/PastOrder/PastOrderService";
import { getAllIndustryDetailslist } from "../../../service/BusinessUnit/BusinessUnitService";
import Checkbox from "../../components/Checkbox";
import moment from "moment";
import * as XLSX from "xlsx";
import {
  getAllProductsSupplierlist,
  getSupplierById,
  getAllInvoiceSupplierInvoicelist,
  getAllOrderSupplierInvoicelist,
} from "../../../service/Suppliers/SuppliersService";
import { City, Country, State } from "country-state-city";
import { CSVLink } from "react-csv";

import {
  getFamilyList,
  getClassList,
  getCommodityUnspcList,
  getSegmentList,
  getActiveProduct,
  getAllProductDetailslist,
  getUnspcAdd,
  addUnspscData,
} from "../../../service/Product/ProductService";

import { format } from "date-fns";
import SpinnerComponent from "../../components/SpinnerComponent";
import ReactPaginate from "react-paginate";
import instance from "../../../WebApi/WebApi";
import { toast } from "react-toastify";
import { getAllGHGlist } from "../../../service/ghg/ghgService";
import { getAllCurrencyData } from "../../../service/Currency/CurrencyService";
import { useTranslation } from "react-i18next";
import useUnitData from "../products/UnitData";
import {
  getClassUnspcAdd,
  getFamilyUnspcAdd,
  getSegmentUnspcAdd,
  searchUnspc,
  getSelectedUnspscDetails,
} from "../../../service/Segment/SegmentService";
import { debounce } from "lodash";

const TreeItem = ({ title, children, onClick, isOpen, toggleOpen }) => {
  return (
    <div style={{ marginLeft: "20px" }}>
      <div style={{ display: "flex", margin: "5px" }}>
        <div
          onClick={toggleOpen}
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          {!title.startsWith("Commodity Code") && (
            <span style={{ marginRight: "5px" }}>{isOpen ? "−" : "+"}</span>
          )}
          {title}
        </div>
        {/* {<ConditionalContent />} */}

        {/* {!title.startsWith("Segment Code") && (
          <div>
            <Button
              variant="success"
              style={{
                height: "24px",
                padding: "1px 2px",
                marginLeft: "5px",
              }}
            >
              GL Key
            </Button>
          </div>
        )} */}
      </div>

      {isOpen && <div>{children}</div>}
    </div>
  );
};

const Supplierdetailsinfo = () => {
  //Search
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalSearchResult, setTotalSearchResult] = useState(0);
  const [search, setSearch] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchResultsEnd, setSearchResultsEnd] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [selectedSearchResult, setSelectedSearchResult] = useState("");

  const { t } = useTranslation();
  const navigate = useNavigate();
  const unitData = useUnitData();
  const [getProductId, setProductId] = useState([]);
  const location = useLocation();
  const supplierId = new URLSearchParams(location.search);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [OrderstartDate, setOrderStartDate] = useState();
  const [OrderendDate, setOrderEndDate] = useState();
  const [isToggled, setToggled] = useState(true);
  const [isToggleddata, setToggleddata] = useState(false);

  const [getSupplierId, setSupplierId] = useState([]);
  const [getProductsInvoiceId, setSupplierProductId] = useState([]);
  const [getSupplierInvoiceId, setSupplierInvoiceId] = useState([]);
  const [getSupplierOrderId, setSupplierOrderId] = useState([]);
  const [invoiceBusinessDataList, setAllInvoiceBusinessDataList] = useState([]);
  const [finalStartDate, setFinalStartDate] = useState("");
  const [finalEndDate, setFinalEndDate] = useState("");
  const [finalOrderStartDate, setOrderFinalStartDate] = useState("");
  const [finalOrderEndDate, setOrderFinalEndDate] = useState("");
  const [pastOrderList, setAllPastOrderList] = useState([]);
  const [businessUnit, setBusinessUnit] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showUnspc, setShowUnspc] = useState(false);
  const [vat, setVat] = useState("");
  const [month, setMonth] = useState("");

  const [allUnspcList, setAllUnspcList] = useState([]);
  const [familyList, setFamilyList] = useState([]);
  const [classList, setClassList] = useState([]);
  const [commodityList, setCommodityList] = useState([]);

  const [segmentData, setSegmentData] = useState({});
  const [familyData, setFamilyData] = useState({});
  const [classData, setClassData] = useState({});
  const [commodityData, setCommodityData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [jsonResult, setJsonResult] = useState(null);
  const [icon, setIcon] = useState("");
  const [status, setStatus] = useState(false);
  const [ghgData, setGhgData] = useState("");
  const [ghgList, setGhgList] = useState([]);
  const [currencyData, setAllCurrencyData] = useState("");
  const [defaultGHG, setDefaultGHG] = useState();
  const [logs, setLogs] = useState(false);
  const [allLogs, setAllLogs] = useState();
  const [purchaseHistory, setPurchaseHistory] = useState([]);
  const [purchaseModal, setPurchaseModal] = useState(false);
  const [selectedAll, setSelectedAll] = useState(false);
  const [selectedCO2, setSelectedCO2] = useState([]);
  const [selectedCO2All, setSelectedCO2All] = useState(false);
  const [co2Modal, setCO2Modal] = useState(false);
  const [co2Id, setCO2Id] = useState("");
  const [co2Info, setCO2Info] = useState({});
  const [searchOptions, setSearchOptions] = useState([]);
  const [segmentDataList, setAllSegmentDataList] = useState([]);
  const [getDataSegment, setDataSegment] = useState("");
  const [allUnspcFamily, setUnspcFamily] = useState([]);
  const [allUnspcClass, setUnspcClass] = useState([]);
  const [allUnspcComodity, setUnspcComodity] = useState([]);
  const [getDataFamily, setDataFamily] = useState("");
  const [supplier, setSupplier] = useState([]);
  const [baseInfo, setBaseInfo] = useState({});
  const [baseUnitModal, setBaseUnitModal] = useState(false);
  const [tabValue, setTabVal] = useState("Supplier");
  const [stateData, setState] = useState([]);
  const [cityData, setCity] = useState([]);

  let countryData = Country.getAllCountries();
  const [GHGDes, setGHGDes] = useState("");

  const [currentPage, setCurrentPage] = useState(0);

  const [openSegment, setOpenSegment] = useState(null);
  const [openFamily, setOpenFamily] = useState(null);
  const [openClass, setOpenClass] = useState(null);

  const handleSegmentClick = (segment) => {
    setOpenSegment(openSegment === segment ? null : segment);
    if (onDataSegment) onDataSegment(segment);
  };

  const handleFamilyClick = (segment, family) => {
    setOpenFamily(openFamily === family ? null : family);
    setOpenClass(null); // Close all classes when a new family is opened
    if (onDataFamily) onDataFamily(family);
  };

  const handleClassClick = (family, classItem) => {
    setOpenClass(openClass === classItem ? null : classItem);
    if (onDataClass) onDataClass(classItem);
  };

  const PER_PAGE = 10;
  const userEmail = JSON.parse(localStorage.getItem("gs3_User")).email;

  const handleCloseCo2Modal = () => setCO2Modal(false);
  const handleCloseBaseModal = () => setBaseUnitModal(false);

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };
  const handleCloseLogs = () => setLogs(false);
  const offset = currentPage * PER_PAGE;
  const currentPageData = getProductsInvoiceId.slice(offset, offset + PER_PAGE);

  const pageCount = Math.ceil(getProductsInvoiceId?.length / PER_PAGE);

  const sortedData = ghgList?.sort((a, b) => {
    if (a.key < b.key) return -1;
    if (a.key > b.key) return 1;
    return 0;
  });

  const onLogs = (e, id) => {
    e.preventDefault();
    getAllLogs(id);
  };
  const getAllLogs = async (id) => {
    const data = {
      productId: id,
    };
    setIsLoading(true);
    try {
      const response = await instance.post(
        `/customer/product/get-product-log`,
        data
      );
      console.log("response-->", response);
      if (response?.data?.success) {
        setAllLogs(response?.data?.data?.productLog);
        setLogs(true);
        setIsLoading(false);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (defaultGHG) {
      ghgText();
    }
  }, [defaultGHG, ghgList]);
  const ghgText = useCallback(() => {
    const filterData = ghgList?.filter(
      (item) => item?.id === Number(defaultGHG)
    );
    console.log("filterData", filterData);
    setGHGDes(filterData[0]?.value);
  }, [defaultGHG, ghgList]);

  const handleCloseUnspc = () => {
    setFamilyList([]);
    setClassList([]);
    setCommodityList([]);
    setSegmentData({});
    setFamilyData({});
    setClassData({});
    setCommodityData({});
    setShowUnspc(false);
    setSelected([]);
  };

  useEffect(() => {
    setTabVal(localStorage.getItem("tab") || "Supplier");
    getallSupplierList();
    getallSupplierInvoiceList();
    getInvoiceBusniessDataList();
    getallSupplierOrderList();
    getallSupplierProductsList();
    getSegmentAddList();
    getGHGDataList();
    getCurrencyData();
    getSegmentAddList();
  }, []);
  async function getCurrencyData() {
    getAllCurrencyData().then(function (result) {
      // console.log(result.data, "datadatadatadatada")
      const response = result.data;
      // console.log(response, "rrrr")
      setAllCurrencyData(response?.data?.availablecurrencyList);
    });
  }

  async function getGHGDataList() {
    setIsLoading(true);
    getAllGHGlist().then(function (result) {
      const response = result?.data;
      setGhgList(response?.data?.ghgList);
      setIsLoading(false);
    });
  }

  async function getSegmentAddList() {
    setIsLoading(true);
    getSegmentList().then(function (result) {
      const response = result.data;
      setAllUnspcList(
        response?.data?.segmentList.map((item) => {
          return { id: item.id, value: item.Segment, label: item.SegmentTitle };
        })
      );
      setIsLoading(false);
    });
  }

  async function getInvoiceBusniessDataList() {
    setIsLoading(true);
    getAllIndustryDetailslist().then(function (result) {
      const response = result?.data;
      setAllInvoiceBusinessDataList(response?.data);
      setIsLoading(false);
    });
  }

  async function getallSupplierList() {
    setIsLoading(true);
    getSupplierById(supplierId.get(`id`)).then(function (result) {
      const response = result.data;
      console.log(response, "response");
      setSupplierId(response?.data?.supplierDetails);
      setState(
        State.getStatesOfCountry(response?.data?.supplierDetails?.country)
      );
      setCity(
        City.getCitiesOfState(
          response?.data?.supplierDetails?.country,
          response?.data?.supplierDetails?.state
        )
      );
      setDefaultGHG(response?.data?.supplierDetails?.MasterGHGId);
      setIsLoading(false);
      // setDepartmentId(response?.data?.businessUnit?.Departments);
    });
  }

  async function getallSupplierInvoiceList() {
    setIsLoading(true);
    getAllInvoiceSupplierInvoicelist(supplierId.get(`id`)).then(function (
      result
    ) {
      const response = result.data;
      console.log(response, "response");
      setSupplierInvoiceId(response?.data?.InvoiceList);
      setIsLoading(false);
    });
  }

  async function getallSupplierOrderList() {
    setIsLoading(true);
    getAllOrderSupplierInvoicelist(supplierId.get(`id`)).then(function (
      result
    ) {
      const response = result.data;
      console.log(response, "response");
      setSupplierOrderId(response?.data?.orderList);
      setIsLoading(false);
    });
  }

  function selectAll(e) {
    if (e.target.checked) {
      const filterData = getProductsInvoiceId.filter((data) => data?.isActive);
      setSelectedAll(true);
      setSelected(filterData);
    } else {
      setSelectedAll(false);
      setSelected([]);
    }
  }
  async function getallProductList() {
    setIsLoading(true);
    getAllProductDetailslist("").then(function (result) {
      const response = result.data;
      setProductId(response?.data?.listProduct);
      setIsLoading(false);
    });
  }

  const handleActive = (id, isActive) => {
    setIsLoading(true);
    getActiveProduct("Product", id, isActive ? false : true, (r) => {
      if (r.success === true) {
        getallProductList();
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    });
  };

  async function getallSupplierProductsList() {
    setIsLoading(true);
    getAllProductsSupplierlist(supplierId.get(`id`)).then(function (result) {
      const response = result.data;
      console.log(response, "response");
      setSupplierProductId(response?.data?.listProduct);
      setIsLoading(false);
    });
  }

  const onOrderBusinessUnit = (e) => {
    setIsLoading(true);
    const ArrBus = e.target.value ? [e.target.value] : [];
    businessUnit.push(e.target.value);
    setBusinessUnit(businessUnit);

    getAllOrderSupplierInvoicelist(
      supplierId.get(`id`),
      Number(ArrBus),
      finalOrderStartDate,
      finalOrderEndDate
    ).then(function (result) {
      const response = result?.data;
      console.log(response, "rrrr");
      setSupplierOrderId(response?.data?.orderList);
      setIsLoading(false);
    });
  };

  const onOrderFromDate = (e) => {
    setIsLoading(true);
    setOrderStartDate(e);
    console.log(e, "eeeeeeeeeeeeeee");
    const fromDate = moment(e).format("YYYY-MM-DD");
    console.log(fromDate, "fromDate");
    setOrderFinalStartDate(fromDate);
    getAllOrderSupplierInvoicelist(
      supplierId.get(`id`),
      businessUnit,
      fromDate,
      finalOrderEndDate
    ).then(function (result) {
      const response = result?.data;
      console.log(response, "rrrr");
      setSupplierOrderId(response?.data?.orderList);
      setIsLoading(false);
    });
  };

  const onOrderToDate = (e) => {
    setIsLoading(true);
    setOrderEndDate(e);
    console.log(e, "eeeeeeeeeeeeeee");
    const toDate = moment(e).format("YYYY-MM-DD");
    setOrderFinalEndDate(toDate);
    getAllOrderSupplierInvoicelist(
      supplierId.get(`id`),
      businessUnit,
      finalOrderStartDate,
      toDate
    ).then(function (result) {
      const response = result?.data;
      console.log(response, "rrrr");
      setSupplierOrderId(response?.data?.orderList);
      setIsLoading(false);
    });
  };

  const onFromDate = (e) => {
    setIsLoading(true);
    setStartDate(e);
    console.log(e, "eeeeeeeeeeeeeee");
    const fromDate = moment(e).format("YYYY-MM-DD");
    console.log(fromDate, "fromDate");
    setFinalStartDate(fromDate);
    getAllInvoiceSupplierInvoicelist(
      supplierId.get(`id`),
      businessUnit,
      fromDate,
      finalEndDate
    ).then(function (result) {
      const response = result?.data;
      console.log(response, "rrrr");
      setSupplierInvoiceId(response?.data?.InvoiceList);
      setIsLoading(false);
    });
  };

  const onToDate = (e) => {
    setIsLoading(true);
    setEndDate(e);
    console.log(e, "eeeeeeeeeeeeeee");
    const toDate = moment(e).format("YYYY-MM-DD");
    setFinalEndDate(toDate);
    getAllInvoiceSupplierInvoicelist(
      supplierId.get(`id`),
      businessUnit,
      finalStartDate,
      toDate
    ).then(function (result) {
      const response = result?.data;
      console.log(response, "rrrr");
      setSupplierInvoiceId(response?.data?.InvoiceList);
      setIsLoading(false);
    });
  };

  const addOneDayToDate = (date) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate());
    return newDate;
  };

  const onMonth = (e) => {
    setIsLoading(true);
    setMonth(Number(e.target.value ? e.target.value : 12));
    getAllProductsSupplierlist(
      supplierId.get(`id`),
      vat,
      Number(e.target.value ? e.target.value : 12),
      isToggleddata
    ).then(function (result) {
      const response = result?.data;
      setSupplierProductId(response?.data?.listProduct);
      setIsLoading(false);
    });
  };

  const onUnspc = (e, data = "") => {
    e.preventDefault();
    setShowUnspc(true);
    if (data) {
      setSelected([data]);
    }
  };

  const onDataSegment = (e) => {
    setIsLoading(true);
    // console.log(e, "sesesegegegege")
    setDataSegment(e);
    getSegmentUnspcAdd(e, (r) => {
      if (r.success === true) {
        // setAllIndustryId('');
        setUnspcFamily(r?.data?.listUnspsc);
        setIsLoading(false);

        // toast.success(r.message)
      } else {
        setIsLoading(false);
        toast.error(r.message);
      }
    });
  };

  const onDataFamily = (e) => {
    setIsLoading(true);
    // console.log(e, "sesesegegegege")
    setDataFamily(e);

    getFamilyUnspcAdd(getDataSegment, e, (r) => {
      if (r.success === true) {
        // setAllIndustryId('');
        setUnspcClass(r?.data?.listUnspsc);
        setIsLoading(false);

        // toast.success(r.message)
      } else {
        setIsLoading(false);
        toast.error(r.message);
      }
    });
  };

  const onDataClass = (e) => {
    setIsLoading(true);
    // console.log(e, "sesesegegegege")
    setDataFamily(e);

    getClassUnspcAdd(getDataSegment, getDataFamily, e, (r) => {
      if (r.success === true) {
        // setAllIndustryId('');
        setUnspcComodity(r?.data?.listUnspsc);
        setIsLoading(false);

        // toast.success(r.message)
      } else {
        setIsLoading(false);
        toast.error(r.message);
      }
    });
  };

  const _RESET = (e) => {
    setIsLoading(true);
    e.preventDefault();
    setMonth("");
    setToggleddata(false);
    setFinalEndDate("");
    setFinalStartDate("");
    setStartDate("");
    setEndDate("");
    setBusinessUnit([]);
    setOrderStartDate("");
    setOrderEndDate("");
    setOrderFinalStartDate("");
    setOrderFinalEndDate("");
    getAllProductsSupplierlist(supplierId.get(`id`), vat, "").then(function (
      result
    ) {
      const response = result?.data;
      setSupplierProductId(response?.data?.listProduct);
      setIsLoading(false);
    });

    getAllInvoiceSupplierInvoicelist(supplierId.get(`id`), "", "", "").then(
      function (result) {
        const response = result?.data;
        // console.log(response, "rrrr");
        setSupplierInvoiceId(response?.data?.InvoiceList);
      }
    );

    getAllOrderSupplierInvoicelist(supplierId.get(`id`), "", "", "").then(
      function (result) {
        const response = result?.data;
        console.log(response, "rrrr");
        setSupplierOrderId(response?.data?.orderList);
        setIsLoading(false);
      }
    );
  };
  async function getSegmentAddList() {
    setIsLoading(true);
    getSegmentList().then(function (result) {
      const response = result.data;
      setAllUnspcList(
        response?.data?.segmentList.map((item) => {
          return { id: item.id, value: item.Segment, label: item.SegmentTitle };
        })
      );
      setAllSegmentDataList(response?.data?.segmentList);
      setIsLoading(false);
    });
  }

  function convertToArrayOfObjects(array) {
    const result = [];
    for (let index = 0; index < array.length; index++) {
      result.push({
        value: {
          code: array[index].Segment.Segment,
          point: "Segment",
          title: array[index].Segment.SegmentTitle,
          id: array[index].Segment.id,
        },
        label: `${array[index].Segment.SegmentTitle} ( Segment - ${array[index].Segment.Segment})`,
      });
      result.push({
        value: {
          code: array[index].Family.Family,
          point: "Family",
          title: array[index].Family.FamilyTitle,
          id: array[index].Family.id,
        },
        label: `${array[index].Family.FamilyTitle} ( Family - ${array[index].Family.Family})`,
      });
      result.push({
        value: {
          code: array[index].Class.Class,
          point: "Class",
          title: array[index].Class.ClassTitle,
          id: array[index].Class.id,
        },
        label: `${array[index].Class.ClassTitle} ( Class - ${array[index].Class.Class})`,
      });
      result.push({
        value: {
          code: array[index].Commodity.Commodity,
          point: "Commodity",
          title: array[index].Commodity.CommodityTitle,
          id: array[index].Commodity.id,
        },
        label: `${array[index].Commodity.CommodityTitle} ( Commodity - ${array[index].Commodity.Commodity})`,
      });
    }
    let jsonObject = result.map(JSON.stringify);
    let uniqueSet = new Set(result.map(JSON.stringify));
    let uniqueArray = Array.from(uniqueSet).map(JSON.parse);
    // console.log(uniqueArray,"res1")
    setSearchOptions(uniqueArray.filter((item) => item.value !== null));
    setIsLoading(false);
    // return uniqueArray;
  }

  const sampleDocumentData = [
    { label: "vendorName", key: "vendorName" },
    { label: "vendorId", key: "vendorId" },
    { label: "ProductName", key: "name" },
    { label: "ProductNumber", key: "number" },
    { label: "Sale_unit", key: "sale_unit_of_measure" },
    { label: "Base_unit", key: "base_unit_of_measure" },
    { label: "Baseunit_qty", key: "baseUnit" },
    { label: "Sub_unit", key: "sub_unit_of_measure" },
    { label: "Subunit_qty", key: "subUnitQty" },
    { label: "CO2_unit", key: "co2_unt_measure" },
    { label: "CO2unit_qty", key: "co2_qty" },
    { label: "KgCO2perCO2unit", key: "kgco2_co2_unit" },
    { label: "GrossWeight", key: "grossWeight" },
    { label: "NetWeight", key: "netWeight" },
    { label: "UNSPSCnumber", key: "UNSPSC" },
    { label: "product_web_store_url", key: "product_web_store_url" },
    { label: "ManufactureProductNumber", key: "manufactureProductNumber" },
    { label: "ManufactureName", key: "manufactureName" },
    { label: "ManufacturerCountryofOrigin", key: "country" },
  ];

  const generalTableData = getProductsInvoiceId?.map((item) => ({
    id: item?.id,
    supplierName: item?.supplierShortName || "----",
    supplierId: item?.supplierId,
    productNumber: item?.number || "----",
    productName: item?.name || "----",
    UNSPSC:
      item?.type === "Family"
        ? item?.unspscFamily?.FamilyTitle
        : item?.type === "Class"
        ? item?.unspscClass?.ClassTitle
        : item?.type === "Commodity"
        ? item?.unspscCommodity?.CommodityTitle
        : item?.type === "Segment"
        ? item?.unspscSegment?.SegmentTitle
        : "",

    listPrice: item?.salePrice,
    discount: item?.discount,
    purchasePrice:
      Number(
        item?.salePrice - Number(item?.salePrice * item?.discount) / 100
      ) || "----",
    baseUnit: item?.baseUnit || "----",
    purchasePriceBase: Number(item?.baseUnit)
      ? (
          Number(
            item?.salePrice - Number(item?.salePrice * item?.discount) / 100
          ) / Number(item?.baseUnit)
        ).toFixed(2)
      : "----",
    kgco2_co2_unit: item?.kgco2_co2_unit || "----",
    productUpdatedAt: item?.productUpdatedAt || "----",
    isActive: item?.isActive,
  }));
  const UNSPSCTableData = getProductsInvoiceId?.map((item) => ({
    id: item?.id,
    supplierName: item?.supplierShortName || "----",
    supplierId: item?.supplierId,
    productNumber: item?.number || "----",
    productName: item?.name || "----",
    UNSPSC:
      item?.type === "Family"
        ? item?.unspscFamily?.FamilyTitle
        : item?.type === "Class"
        ? item?.unspscClass?.ClassTitle
        : item?.type === "Commodity"
        ? item?.unspscCommodity?.CommodityTitle
        : item?.type === "Segment"
        ? item?.unspscSegment?.SegmentTitle
        : "",

    sale_unit_of_measure: item?.sale_unit_of_measure || "----",
    base_unit_of_measure: item?.base_unit_of_measure || "----",
    baseUnit: item?.baseUnit || "----",
    sub_unit_of_measure: item?.sub_unit_of_measure || "----",

    subUnitQty: item?.subUnitQty || "----",
    isActive: item?.isActive,
  }));
  const CO2TableData = getProductsInvoiceId.map((item) => ({
    id: item?.id,
    supplierId: item?.supplierId,
    supplierName: item?.supplierShortName,
    supplierId: item?.supplierId,
    productNumber: item?.number,
    productName: item?.name,
    co2_unt_measure: item?.co2_unt_measure,
    co2_qty: item?.co2_qty,
    kgco2_co2_unit: item?.kgco2_co2_unit,
    KgCO2_per_Sale_unit: item?.KgCO2_per_Sale_unit,
    manufactureName: item?.manufactureName,
    manufactureProductNumber: item?.manufactureProductNumber,

    subUnitQty: item?.subUnitQty,
    country: item?.country,
    isActive: item?.isActive,
  }));

  const UNSPSCAndCO2Header = [
    { label: "Vendor", key: "supplierName" },
    { label: "Product Number", key: "productNumber" },
    { label: "Product Name", key: "productName" },
    { label: "Sale unit of measure", key: "sale_unit_of_measure" },
    { label: "Base unit of measure", key: "base_unit_of_measure" },
    { label: "Base unit quantity", key: "baseUnitPrice" },
    { label: "Sub unit of measure", key: "sub_unit_of_measure" },
    { label: "Sub unit quantity", key: "subUnitQty" },
    { label: "UNSPSC", key: "UNSPSC" },
    { label: "CO2 unit of measure", key: "co2_unit" },
    { label: "CO2 unit quantity", key: "co2_qty" },
    { label: "KgCO2 per CO2 unit", key: "KgCO2_per_co2_unit" },
    { label: "KgCO2 per Sale unit", key: "KgCO2_per_sale_unit" },
    { label: "Manufacturer name", key: "baseUnitPrice" },
    { label: "Manufacturer product number", key: "sub_unit_of_measure" },
    { label: "Manufacturer country of origin", key: "origin" },
  ];
  const UNSPSCAndCO2Data = getProductsInvoiceId?.map((item) => ({
    supplierName: item?.supplierShortName || "----",
    productNumber: item?.productId || "----",
    productName: item?.productName || "----",

    sale_unit_of_measure: item?.sale_unit_of_measure || "----",
    base_unit_of_measure: item?.base_unit_of_measure || "----",
    baseUnitPrice: item?.baseUnitPrice || "----",
    sub_unit_of_measure: item?.sub_unit_of_measure || "----",
    subUnitQty: item?.subUnitQty || "----",
    UNSPSC:
      item?.type === "Family"
        ? item?.unspscFamily?.FamilyTitle
        : item?.type === "Class"
        ? item?.unspscClass?.ClassTitle
        : item?.type === "Commodity"
        ? item?.unspscCommodity?.CommodityTitle
        : item?.type === "Segment"
        ? item?.unspscSegment?.SegmentTitle
        : "",
    co2_unt_measure: item?.co2_unt_measure,
    co2_qty: item?.co2_qty,
    kgco2_co2_unit: item?.kgco2_co2_unit,
    KgCO2_per_Sale_unit: item?.KgCO2_per_Sale_unit,
    manufactureName: item?.manufactureName,
    manufactureProductNumber: item?.manufactureProductNumber,
    country: item?.country,
    isActive: item?.isActive,
  }));

  // General Product Column
  const generalProductColumn = [
    { label: t("generalProductColumn.supplier"), key: "supplierName" },
    { label: t("generalProductColumn.productNumber"), key: "productNumber" },
    { label: t("generalProductColumn.productName"), key: "productName" },
    { label: t("generalProductColumn.UNSPSC"), key: "UNSPSC" },
    { label: t("generalProductColumn.listPrice"), key: "listPrice" },
    { label: t("generalProductColumn.discount"), key: "discount" },
    { label: t("generalProductColumn.purchasePrice"), key: "purchasePrice" },
    { label: t("generalProductColumn.baseUnit"), key: "baseUnit" },
    {
      label: t("generalProductColumn.purchasePriceBase"),
      key: "purchasePriceBase",
    },
    {
      label: t("generalProductColumn.KgCO2_per_CO2_unit"),
      key: "KgCO2_per_CO2_unit",
    },
    {
      label: t("generalProductColumn.productUpdatedAt"),
      key: "productUpdatedAt",
    },
  ];

  // UNSPSC Column
  const UNSPSCColumn = [
    { label: t("UNSPSCColumn.supplier"), key: "supplierName" },
    { label: t("UNSPSCColumn.productNumber"), key: "productNumber" },
    { label: t("UNSPSCColumn.productName"), key: "productName" },
    { label: t("UNSPSCColumn.saleUnitOfMeasure"), key: "sale_unit_of_measure" },
    { label: t("UNSPSCColumn.baseUnitOfMeasure"), key: "base_unit_of_measure" },
    { label: t("UNSPSCColumn.baseUnitPrice"), key: "baseUnitPrice" },
    { label: t("UNSPSCColumn.subUnitOfMeasure"), key: "sub_unit_of_measure" },
    { label: t("UNSPSCColumn.subUnitQty"), key: "subUnitQty" },
    { label: t("UNSPSCColumn.UNSPSC"), key: "UNSPSC" },
  ];

  // CO2 Column
  const CO2Column = [
    { label: t("CO2Column.supplierId"), key: "supplierId" },
    { label: t("CO2Column.supplierName"), key: "supplierName" },
    { label: t("CO2Column.productNumber"), key: "productNumber" },
    { label: t("CO2Column.productName"), key: "productName" },
    { label: t("CO2Column.saleUnitOfMeasure"), key: "sale_unit_of_measure" },
    { label: t("CO2 unit quantity"), key: "co2_qty" },
    { label: t("CO2Column.KgCO2_per_CO2_unit"), key: "KgCO2_per_CO2_unit" },
    { label: t("CO2Column.KgCO2_per_sale_unit"), key: "KgCO2_per_sale_unit" },
    { label: t("CO2Column.baseUnitPrice"), key: "baseUnitPrice" },
    { label: t("CO2Column.subUnitOfMeasure"), key: "sub_unit_of_measure" },
    { label: t("CO2Column.subUnitQty"), key: "subUnitQty" },
  ];

  const onClose = () => {
    setShowModal(false);
  };

  const _SEARCH_UNSPSC = debounce((data) => {
    setIsLoading(true);
    searchUnspc(data, (res) => {
      convertToArrayOfObjects(res.data);
    });
  }, 500);

  const _SELECT_UNSPSC = (data) => {
    setIsLoading(true);
    // console.log(data,"myData");
    getUnspcAdd(data, selected, (r) => {
      if (r.success === true) {
        toast.success(r.message);
        setShowUnspc(false);
        afterUpdateUnspschandledata();
        getallSupplierProductsList();
        setIsLoading(false);
        setSelected([]);
        setSelectedAll(false);
      } else {
        setIsLoading(false);
        toast.error(r.message);
      }
    });
  };
  const afterUpdateUnspschandledata = () => {
    // setToggleddata(!isToggleddata);
    getAllProductDetailslist(
      supplier,
      vat,
      month,
      isToggleddata,
      finalStartDate,
      finalEndDate
    ).then(function (result) {
      const response = result?.data;
      console.log(response, "rrrr");
      setProductId(response?.data?.listProduct);
    });
  };

  const IMPORT_SUPPLIER = async (e) => {
    e.preventDefault();

    // setIsLoading(true);
    setShowModal(false);
    console.log(jsonResult, "jsonResult");

    try {
      // const res = await importProduct({ Products: jsonResult });
      const res = await instance.post(
        `/customer/supplier/import-product-supplier`,
        { Products: jsonResult }
      );
      console.log("ress66", res);

      if (res.status === 200) {
        getallSupplierProductsList();
        toast.success(res.data.message);
        setIsLoading(false);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const OPEN_MODAL = () => {
    console.log("opennnn");
    setShowModal(true);
  };

  function handleChange(event) {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: "binary" });

          // Assuming the first sheet is the one you want to convert
          const sheetName = workbook.SheetNames[0];
          const sheetData = XLSX.utils.sheet_to_json(
            workbook.Sheets[sheetName]
          );
          setJsonResult(sheetData);
        } catch (error) {
          console.error("Error converting Excel to JSON:", error);
        }
      };

      reader.readAsBinaryString(file);
    }

    setIcon(
      "data:image/png;base64,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"
    );
  }
  const getPurchasePrice = (salePrice, discount) => {
    return discount
      ? Number(salePrice) - Number(salePrice) * (Number(discount) / 100)
      : salePrice;
  };

  const handleUpdate = async () => {
    const data = getSupplierId;
    data.supplierId = supplierId.get(`id`);
    try {
      const response = await instance.post(
        `/customer/supplier/edit-supplier`,
        data
      );
      if (response?.data?.success) {
        toast.success(response?.data?.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
  };
  const onPurchase = (e, id) => {
    e.preventDefault();
    getPurchaseHistory(id);
  };
  const getPurchaseHistory = async (id) => {
    const data = {
      productId: id,
    };
    const response = await instance.post(
      `/customer/product/get-purchase-history-by-id`,
      data
    );
    setPurchaseHistory(response?.data?.data?.purchaseHistories);
    setPurchaseModal(true);
  };

  const onUNSPSCCheck = (id) => {
    if (id) {
      if (selected.some((item) => item.id == id.id)) {
        const filterData = selected.filter((item) => item?.id !== id?.id);
        setSelected(filterData);
      } else {
        setSelected([...selected, id]);
      }
    }
  };

  const onCo2 = (e, d) => {
    setCO2Modal(true);
    setCO2Id(d?.id);
  };

  const onCO2Check = (id) => {
    if (id) {
      if (selectedCO2.includes(id)) {
        const filterData = selectedCO2.filter((item) => item !== id);
        console.log("ifffff", filterData);
        setSelectedCO2(filterData);
      } else {
        setSelectedCO2([...selectedCO2, id]);
      }
    }
  };

  const onCO2CheckAll = (e) => {
    if (e.target.checked) {
      const filterData = getProductsInvoiceId
        .filter((data) => data?.isActive)
        .map((item) => item?.id);
      setSelectedCO2All(true);
      setSelectedCO2(filterData);
    } else {
      setSelectedCO2All(false);
      setSelectedCO2([]);
    }
  };

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setCO2Info({
      ...co2Info,
      [name]: value,
    });
  };

  const handleChangeInputBase = (e) => {
    const { name, value } = e.target;
    setBaseInfo({
      ...baseInfo,
      [name]: value,
    });
  };

  const searchPage = () => {
    navigate("/search-all-unspsc");
  };

  const onBaseUnit = (e) => {
    e.preventDefault();
    setBaseUnitModal(true);
  };

  const handleUpdateCo2 = async () => {
    const productIds = selectedCO2.map((d) => ({ id: d }));
    const data = {
      products: productIds,
      co2_qty: co2Info?.co2_qty,
      co2_unt_measure: co2Info?.co2_unt_measure,
      kgco2_co2_unit: co2Info?.kgco2_co2_unit,
    };
    try {
      const response = await instance.post(
        `/customer/product/edit-co2-for-product`,
        data
      );
      console.log("response----->", response);
      handleCloseCo2Modal();
      setSelectedCO2([]);
      getallSupplierProductsList();
    } catch (err) {
      console.log(err);
    }
  };
  const handleUpdateBase = async () => {
    const productIds = selected.map((d) => ({ id: d?.id }));
    const data = {
      products: productIds,
      baseUnit: baseInfo?.baseUnit,
      base_unit_of_measure: baseInfo?.base_unit_of_measure,
      subUnitQty: baseInfo?.subUnitQty,
      sub_unit_of_measure: baseInfo?.sub_unit_of_measure,
    };
    try {
      const response = await instance.post(
        `/customer/product/edit-co2-for-product`,
        data
      );
      console.log("response----->", response);
      handleCloseBaseModal();
      setSelected([]);
      getallSupplierProductsList();
    } catch (err) {
      console.log(err);
    }
  };

  const handleCountry = async (con, id) => {
    const data = {
      country: con,
      productId: id,
    };
    await instance.post(`/customer/product/edit-product`, data);
    getallProductList();
  };

  const handleTabSelect = (eventKey) => {
    setTabVal(eventKey);
    localStorage.setItem("tab", "Supplier");
  };

  // Search Section
  const searchUnspsc = debounce((input) => {
    setSearch("");
    setPage(1);
    setTotalSearchResult(0);
    setSearchResults([]);

    if (!input) {
      return;
    }

    setSearch(input);
  }, 1500);

  const loadMoreResults = () => {
    setPage(page + 1);
  };

  function getSearchResults() {
    setIsSearchLoading(true);

    searchUnspc(search, page, "user", (res) => {
      if (!res.data || res.data.results.length === 0) {
        setSearchResults([]);
        setIsSearchLoading(false);
        return;
      }

      setSearchResults((prevResults) => [...prevResults, ...res.data.results]);
      setTotalSearchResult(res.data.total);
      setSearchResultsEnd(res.data.reachedEnd);
      setIsSearchLoading(false);
    });
  }

  function getUnspscData(result) {
    toast.dismiss();

    toast.warning(
      <div className="toast-content">
        <div className="toast-message">
          Are you sure you want to add this UNSPSC?
        </div>
        <div className="button-container">
          <button
            className="yes-button"
            onClick={() => {
              // Proceed with the function if "Yes" is clicked
              getSelectedUnspscDetails(result, (res) => {
                if (res.success) {
                  addUnspscData(res.data.details, selected, (r) => {
                    if (r.success === true) {
                      toast.success(r.message);
                      setPage(1);
                      setSearchResults([]);
                      setSearch("");
                      handleCloseUnspc();
                      // afterUpdateUnspschandledata();
                      getallSupplierProductsList();
                    } else {
                      toast.error(r.message);
                    }
                  });
                }
              });
            }}
          >
            Yes
          </button>
          <button
            className="no-button ms-2"
            onClick={() => {
              // Dismiss the toast if "No" is clicked
              toast.dismiss();
            }}
          >
            No
          </button>
        </div>
      </div>,
      {
        autoClose: true, // Keep the toast open until user interacts
        closeOnClick: true, // Prevent closing the toast on click
      }
    );
  }

  useEffect(() => {
    getSearchResults();
  }, [search]);

  useEffect(() => {
    if (page > 1) {
      getSearchResults();
    }
  }, [page]);

  return (
    <div className="container-fluid">
      <div className="dbMain suppliersBg">
        <Leftpanel />
        <div className="dbRight">
          <Header
            link="/addsuppliers"
            breadcm=""
            title={`${"Suppliers/"}${tabValue}`}
            description=""
          />
          {isLoading && <SpinnerComponent isLoading={isLoading} />}

          <Modal
            size="lg"
            show={baseUnitModal}
            onHide={handleCloseBaseModal}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <h5 className="mb-0">{t("add")} Base Unit Information</h5>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row">
                <div className="col-md-6 mt">
                  {" "}
                  <label>Base Unit</label>
                  <select
                    className="form-control"
                    name="base_unit_of_measure"
                    onChange={(e) => handleChangeInputBase(e)}
                  >
                    <option value="">Select</option>

                    {unitData?.map((data, index) => (
                      <option key={index} value={data.common_unit}>
                        {data.common_unit}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6 mt">
                  <label>Base Unit Quantity</label>
                  <input
                    type="text"
                    className="form-control"
                    name="baseUnit"
                    onChange={(e) => handleChangeInputBase(e)}
                  />
                </div>
                <div className="col-md-6 mt">
                  {" "}
                  <label>Sub Unit</label>
                  <select
                    className="form-control"
                    name="sub_unit_of_measure"
                    onChange={(e) => handleChangeInputBase(e)}
                  >
                    <option value="">Select</option>

                    {unitData?.map((data, index) => (
                      <option key={index} value={data.common_unit}>
                        {data.common_unit}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6 mt">
                  <label>Sub Unit Quantity</label>
                  <input
                    type="text"
                    className="form-control"
                    name="subUnitQty"
                    onChange={(e) => handleChangeInputBase(e)}
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer style={{ borderTop: "none" }}>
              <Button variant="success" onClick={handleUpdateBase}>
                Save
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            size="lg"
            show={co2Modal}
            onHide={handleCloseCo2Modal}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <h5 className="mb-0">
                  {t("add")} {t("CO2 Information")}
                </h5>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row">
                <div className="col-md-6 mt">
                  {" "}
                  <label>CO2 Unit</label>
                  <select
                    className="form-control"
                    name="co2_unt_measure"
                    onChange={(e) => handleChangeInput(e)}
                  >
                    <option value="">Select</option>

                    {unitData?.map((data, index) => (
                      <option key={index} value={data.common_unit}>
                        {data.common_unit}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6 mt">
                  <label>CO2 Unit Quantity</label>
                  <input
                    type="text"
                    className="form-control"
                    name="co2_qty"
                    onChange={(e) => handleChangeInput(e)}
                  />
                </div>
                <div className="col-md-6 mt">
                  <label>KGCO2 per CO2 Unit</label>
                  <input
                    type="text"
                    className="form-control"
                    name="kgco2_co2_unit"
                    onChange={(e) => handleChangeInput(e)}
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer style={{ borderTop: "none" }}>
              <Button variant="success" onClick={handleUpdateCo2}>
                Save
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            size="lg"
            show={purchaseModal}
            onHide={() => setPurchaseModal(false)}
            dialogClassName="custom-modal-size"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <h4 className="mb-3">{t("Purchase History")}</h4>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="dbMaintable respTable">
                <table>
                  <thead>
                    <tr>
                      <th>{t("Order ID")}</th>
                      <th>{t("Order Date")}</th>
                      <th>{t("User")}</th>
                      <th>{t("Purchase Quantity")}</th>
                      <th>{t("Price")}</th>
                      <th>{t("Change Percentage")}</th>
                    </tr>
                  </thead>

                  <tbody>
                    {purchaseHistory?.length > 0 &&
                      purchaseHistory
                        ?.sort(
                          (a, b) =>
                            new Date(b?.createdAt) - new Date(a?.createdAt)
                        )
                        ?.map((item) => {
                          return (
                            <tr key={item.id}>
                              <td data-label="Order ID">
                                <Link to="javascript:void(0)">
                                  {/* {item.orderId} */}
                                  {item.orderId}
                                </Link>
                              </td>
                              <td data-label="Order Date">
                                <Link to="javascript:void(0)">
                                  {moment(item.createdAt).format("DD-MM-YYYY")}
                                </Link>
                              </td>
                              <td data-label="Order Date">
                                <Link to="javascript:void(0)">
                                  {`${item?.User?.firstName} ${item?.User?.lastName}`}
                                </Link>
                              </td>
                              <td data-label="Total Quantity per Base units">
                                <Link to="javascript:void(0)">
                                  {item.totalQuantityPerBaseUnits}
                                </Link>
                              </td>
                              <td data-label="Base unit Price">
                                <Link to="javascript:void(0)">
                                  {item.currencyType}{" "}
                                  {item.baseUnitPrice.toFixed(2)}
                                </Link>
                              </td>
                              <td data-label="Change Percentage">
                                <Link to="javascript:void(0)">
                                  {item?.changePercentage
                                    ? `${Number(item?.changePercentage).toFixed(
                                        2
                                      )} %`
                                    : "----"}
                                </Link>
                              </td>
                            </tr>
                          );
                        })}
                  </tbody>
                </table>
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            size="lg"
            show={logs}
            onHide={handleCloseLogs}
            dialogClassName="custom-modal-size"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <h4 className="mb-3">{t("All Logs")}</h4>{" "}
                {/* Translated title */}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="dbMaintable respTable">
                <table>
                  <thead>
                    <tr>
                      <th>{t("Date and Time")}</th>
                      <th>{t("User")}</th>
                      <th>{t("Discount")}</th>
                      <th>{t("CO2 unit Quantity")}</th>
                      <th>{t("KgCO2 per CO2 unit")}</th>
                      <th>{t("Manufacturer prod. number")}</th>
                      <th>{t("Manufacturer name")}</th>
                      <th>{t("Manufacturer Country of Origin")}</th>
                      <th>{t("Gross weight")}</th>
                      <th>{t("Dry weight")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <>
                      {allLogs
                        ?.sort(
                          (a, b) =>
                            new Date(b.createdAt) - new Date(a.createdAt)
                        )
                        ?.map((s) => (
                          <tr key={s.id}>
                            {" "}
                            {/* Added key for each row */}
                            <td data-label={t("Date and Time")}>
                              {moment(s?.createdAt).format(
                                "DD-MM-YYYY,HH:mm:ss"
                              )}
                            </td>
                            <td data-label={t("User")}>
                              <Link to="javascript:void(0)">
                                {`${s?.User?.firstName} ${s?.User?.lastName}`}
                              </Link>
                            </td>
                            <td data-label={t("Discount")}>{s?.discount}</td>
                            <td data-label={t("CO2 unit Quantity")}>
                              {s?.co2_qty}&nbsp;
                            </td>
                            <td data-label={t("KgCO2 per CO2 unit")}>
                              {s?.kgco2_co2_unit}&nbsp;
                            </td>
                            <td data-label={t("Manufacturer prod. number")}>
                              {s?.manufactureProductNumber}&nbsp;
                            </td>
                            <td data-label={t("Manufacturer name")}>
                              {s?.manufactureName}&nbsp;
                            </td>
                            <td
                              data-label={t("Manufacturer Country of Origin")}
                            >
                              {s?.manufactureCountry}&nbsp;
                            </td>
                            <td data-label={t("Gross weight")}>
                              {s?.gross_weight}&nbsp;
                            </td>
                            <td data-label={t("Dry weight")}>
                              {s?.net_weight}&nbsp;
                            </td>
                          </tr>
                        ))}
                    </>
                  </tbody>
                </table>
              </div>
            </Modal.Body>
          </Modal>

          <div className="commonBase p-0">
            <div className="tabsTotal">
              <Tabs
                defaultActiveKey={tabValue}
                id="my-tabs"
                className="supplyerTablink"
                activeKey={tabValue} // Step 3: Control active tab via state
                onSelect={handleTabSelect}
              >
                <Tab eventKey="Supplier" title={t("suppliers")}>
                  <div className="suppTop">
                    <div className="row">
                      <div className="col-md-6">
                        <div style={{ display: "flex" }}>
                          <td>
                            {t("company_id_number")}{" "}
                            {/* <span>{getSupplierId?.supplierCompanyId}</span> */}
                          </td>
                          <td>
                            {" "}
                            <input
                              className="supplierEditInput"
                              type="text"
                              name="supplierCompanyId"
                              value={getSupplierId?.supplierCompanyId}
                              onChange={(e) => {
                                setSupplierId((prevData) => ({
                                  ...prevData,
                                  supplierCompanyId: e.target.value,
                                }));
                              }}
                            />
                          </td>
                        </div>
                        <div style={{ display: "flex" }}>
                          <td>{t("Email")}:</td>
                          <td>
                            <input
                              className="supplierEditInput"
                              type="text"
                              name="email"
                              style={{ width: "150%" }}
                              value={getSupplierId?.email}
                              readOnly
                            />
                          </td>
                        </div>
                        <div style={{ display: "flex" }}>
                          <td>{t("Country")}:</td>
                          <td>
                            <select
                              className="supplierEditInput"
                              name="country"
                              onChange={(e) => (
                                setSupplierId((prevData) => ({
                                  ...prevData,
                                  country: e.target.value,
                                })),
                                setState(
                                  State.getStatesOfCountry(e.target.value)
                                )
                              )}
                            >
                              <option value="">Select Country</option>
                              {countryData?.map((data) => (
                                <option
                                  value={data?.isoCode}
                                  selected={
                                    getSupplierId?.country === data?.isoCode
                                  }
                                >
                                  {data?.name}
                                </option>
                              ))}
                            </select>
                          </td>
                        </div>
                        <div style={{ display: "flex" }}>
                          <td>{t("state")}:</td>
                          <td>
                            <select
                              className="supplierEditInput"
                              name="state"
                              onChange={(e) => (
                                setSupplierId((prevData) => ({
                                  ...prevData,
                                  state: e.target.value,
                                })),
                                setCity(
                                  City.getCitiesOfState(
                                    getSupplierId?.country,
                                    e.target.value
                                  )
                                )
                              )}
                            >
                              <option value="">Select State</option>
                              {stateData?.map((data) => (
                                <option
                                  value={data?.isoCode}
                                  selected={
                                    getSupplierId?.state === data?.isoCode
                                  }
                                >
                                  {data?.name}
                                </option>
                              ))}
                            </select>
                          </td>
                        </div>
                        <div style={{ display: "flex" }}>
                          <td>{t("Address")}:</td>
                          <td>
                            <textarea
                              className="supplierEditInput"
                              type="text"
                              name="address"
                              style={{ width: "220%" }}
                              value={getSupplierId?.address}
                              onChange={(e) => {
                                setSupplierId((prevData) => ({
                                  ...prevData,
                                  address: e.target.value,
                                }));
                              }}
                            />
                          </td>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div style={{ display: "flex" }}>
                          <td>{t("supplier.name")}:</td>
                          <td>
                            <input
                              className="supplierEditInput"
                              type="text"
                              name="name"
                              style={{ width: "150%" }}
                              value={getSupplierId?.name}
                              onChange={(e) => {
                                setSupplierId((prevData) => ({
                                  ...prevData,
                                  name: e.target.value,
                                }));
                              }}
                            />
                          </td>
                        </div>

                        <div style={{ display: "flex" }}>
                          <p>{t("supplier.contactNumber")}:</p>
                          <input
                            className="supplierEditInput"
                            type="text"
                            name="mobile"
                            value={getSupplierId?.mobile}
                            onChange={(e) => {
                              setSupplierId((prevData) => ({
                                ...prevData,
                                mobile: e.target.value,
                              }));
                            }}
                          />
                        </div>

                        <div style={{ display: "flex" }}>
                          <p>{t("supplier.zipCode")}:</p>
                          <input
                            className="supplierEditInput"
                            type="text"
                            name="zipCode"
                            value={getSupplierId?.zipCode}
                            onChange={(e) => {
                              setSupplierId((prevData) => ({
                                ...prevData,
                                zipCode: e.target.value,
                              }));
                            }}
                          />
                        </div>

                        <div style={{ display: "flex" }}>
                          <p>{t("supplier.city")}:</p>
                          <td>
                            <select
                              className="supplierEditInput"
                              name="city"
                              onChange={(e) =>
                                setSupplierId((prevData) => ({
                                  ...prevData,
                                  city: e.target.value,
                                }))
                              }
                            >
                              <option value="">Select City</option>
                              {cityData?.map((data) => (
                                <option
                                  value={data?.name}
                                  selected={getSupplierId?.city === data?.name}
                                >
                                  {data?.name}
                                </option>
                              ))}
                            </select>
                          </td>
                        </div>

                        <div style={{ display: "flex" }}>
                          <p>{t("supplier.website")}:</p>
                          <input
                            className="supplierEditInput"
                            type="text"
                            name="website"
                            value={getSupplierId?.website}
                            onChange={(e) => {
                              setSupplierId((prevData) => ({
                                ...prevData,
                                website: e.target.value,
                              }));
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="suppDividr mb-5">
                    <span className="cricleGreen">{t("Contact persons")}</span>
                  </div>
                  {/* <h6>Products:</h6> */}
                  <div className="compactTable">
                    <table>
                      <thead>
                        <tr>
                          <th>&nbsp;</th>
                          <th>{t("Name")}</th>
                          <th>{t("Email")}</th>
                          <th>{t("Contact number")}</th>
                          <th>{t("Status")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th>{t("products")}:</th>
                          <td>
                            {" "}
                            <input
                              className="productEditInput"
                              type="text"
                              name="ContactPersonProductName"
                              value={getSupplierId?.ContactPersonProductName}
                              onChange={(e) => {
                                setSupplierId((prevData) => ({
                                  ...prevData,
                                  ContactPersonProductName: e.target.value,
                                }));
                              }}
                            />
                          </td>
                          <td>
                            {" "}
                            <input
                              className="productEditInput"
                              type="text"
                              name="ContactPersonProductEmail"
                              value={getSupplierId?.ContactPersonProductEmail}
                              onChange={(e) => {
                                setSupplierId((prevData) => ({
                                  ...prevData,
                                  ContactPersonProductEmail: e.target.value,
                                }));
                              }}
                            />
                          </td>
                          <td>
                            {" "}
                            <input
                              className="productEditInput"
                              type="text"
                              name="ContactPersonProductPhone"
                              value={getSupplierId?.ContactPersonProductPhone}
                              onChange={(e) => {
                                setSupplierId((prevData) => ({
                                  ...prevData,
                                  ContactPersonProductPhone: e.target.value,
                                }));
                              }}
                            />
                          </td>
                          <td>
                            <div className="toggle-container">
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={
                                    getSupplierId?.ContactPersonProductStatus
                                  }
                                  onChange={(e) => {
                                    setSupplierId((prevData) => ({
                                      ...prevData,
                                      ContactPersonProductStatus:
                                        !getSupplierId?.ContactPersonProductStatus,
                                    }));
                                  }}
                                />
                                {getSupplierId?.ContactPersonProductStatus ? (
                                  <span className="slider round"></span>
                                ) : (
                                  <span className="slideroff round"></span>
                                )}
                              </label>
                              <p style={{ marginBottom: "3px" }}>
                                {getSupplierId?.ContactPersonProductStatus
                                  ? t("active")
                                  : t("inactive")}{" "}
                              </p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th>{t("orders")}</th>
                          <td>
                            {" "}
                            <input
                              className="productEditInput"
                              type="text"
                              name="ContactPersonOrderName"
                              value={getSupplierId?.ContactPersonOrderName}
                              onChange={(e) => {
                                setSupplierId((prevData) => ({
                                  ...prevData,
                                  ContactPersonOrderName: e.target.value,
                                }));
                              }}
                            />
                          </td>
                          <td>
                            {" "}
                            <input
                              className="productEditInput"
                              type="text"
                              name="ContactPersonOrderEmail"
                              value={getSupplierId?.ContactPersonOrderEmail}
                              onChange={(e) => {
                                setSupplierId((prevData) => ({
                                  ...prevData,
                                  ContactPersonOrderEmail: e.target.value,
                                }));
                              }}
                            />
                          </td>
                          <td>
                            {" "}
                            <input
                              className="productEditInput"
                              type="text"
                              name="ContactPersonOrderPhone"
                              value={getSupplierId?.ContactPersonOrderPhone}
                              onChange={(e) => {
                                setSupplierId((prevData) => ({
                                  ...prevData,
                                  ContactPersonOrderPhone: e.target.value,
                                }));
                              }}
                            />
                          </td>
                          <td>
                            <div className="toggle-container">
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={
                                    getSupplierId?.ContactPersonOrderStatus
                                  }
                                  onChange={(e) => {
                                    setSupplierId((prevData) => ({
                                      ...prevData,
                                      ContactPersonOrderStatus:
                                        !getSupplierId?.ContactPersonOrderStatus,
                                    }));
                                  }}
                                />
                                {getSupplierId?.ContactPersonOrderStatus ? (
                                  <span className="slider round"></span>
                                ) : (
                                  <span className="slideroff round"></span>
                                )}
                              </label>
                              <p style={{ marginBottom: "3px" }}>
                                {getSupplierId?.ContactPersonOrderStatus
                                  ? t("active")
                                  : t("inactive")}{" "}
                              </p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th>{t("invoices")}</th>
                          <td>
                            {" "}
                            <input
                              className="productEditInput"
                              type="text"
                              name="ContactPersonInvoiceName"
                              value={getSupplierId?.ContactPersonInvoiceName}
                              onChange={(e) => {
                                setSupplierId((prevData) => ({
                                  ...prevData,
                                  ContactPersonInvoiceName: e.target.value,
                                }));
                              }}
                            />
                          </td>
                          <td>
                            {" "}
                            <input
                              className="productEditInput"
                              type="text"
                              name="ContactPersonInvoiceEmail"
                              value={getSupplierId?.ContactPersonInvoiceEmail}
                              onChange={(e) => {
                                setSupplierId((prevData) => ({
                                  ...prevData,
                                  ContactPersonInvoiceEmail: e.target.value,
                                }));
                              }}
                            />
                          </td>
                          <td>
                            {" "}
                            <input
                              className="productEditInput"
                              type="text"
                              name="ContactPersonInvoicePhone"
                              value={getSupplierId?.ContactPersonInvoicePhone}
                              onChange={(e) => {
                                setSupplierId((prevData) => ({
                                  ...prevData,
                                  ContactPersonInvoicePhone: e.target.value,
                                }));
                              }}
                            />
                          </td>
                          <td>
                            <div className="toggle-container">
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={
                                    getSupplierId?.ContactPersonInvoiceStatus
                                  }
                                  onChange={(e) => {
                                    setSupplierId((prevData) => ({
                                      ...prevData,
                                      ContactPersonInvoiceStatus:
                                        !getSupplierId?.ContactPersonInvoiceStatus,
                                    }));
                                  }}
                                />
                                {getSupplierId?.ContactPersonInvoiceStatus ? (
                                  <span className="slider round"></span>
                                ) : (
                                  <span className="slideroff round"></span>
                                )}
                              </label>
                              <p style={{ marginBottom: "3px" }}>
                                {getSupplierId?.ContactPersonInvoiceStatus
                                  ? t("active")
                                  : t("inactive")}{" "}
                              </p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th>{t("qualityIssues")}:</th>
                          <td>
                            {" "}
                            <input
                              className="productEditInput"
                              type="text"
                              name="ContactPersonQualityName"
                              value={getSupplierId?.ContactPersonQualityName}
                              onChange={(e) => {
                                setSupplierId((prevData) => ({
                                  ...prevData,
                                  ContactPersonQualityName: e.target.value,
                                }));
                              }}
                            />
                          </td>
                          <td>
                            {" "}
                            <input
                              className="productEditInput"
                              type="text"
                              name="ContactPersonQualityEmail"
                              value={getSupplierId?.ContactPersonQualityEmail}
                              onChange={(e) => {
                                setSupplierId((prevData) => ({
                                  ...prevData,
                                  ContactPersonQualityEmail: e.target.value,
                                }));
                              }}
                            />
                          </td>
                          <td>
                            {" "}
                            <input
                              className="productEditInput"
                              type="text"
                              name="ContactPersonQualityPhone"
                              value={getSupplierId?.ContactPersonQualityPhone}
                              onChange={(e) => {
                                setSupplierId((prevData) => ({
                                  ...prevData,
                                  ContactPersonQualityPhone: e.target.value,
                                }));
                              }}
                            />
                          </td>
                          <td>
                            <div className="toggle-container">
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={
                                    getSupplierId?.ContactPersonQualityStatus
                                  }
                                  onChange={(e) => {
                                    setSupplierId((prevData) => ({
                                      ...prevData,
                                      ContactPersonQualityStatus:
                                        !getSupplierId?.ContactPersonQualityStatus,
                                    }));
                                  }}
                                />
                                {getSupplierId?.ContactPersonQualityStatus ? (
                                  <span className="slider round"></span>
                                ) : (
                                  <span className="slideroff round"></span>
                                )}
                              </label>
                              <p style={{ marginBottom: "3px" }}>
                                {getSupplierId?.ContactPersonQualityStatus
                                  ? t("active")
                                  : t("inactive")}{" "}
                              </p>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="commonBase mb-4" style={{ padding: "0px" }}>
                    <h6 className="mb-3">{t("add") + " GHG " + t("key")} </h6>
                    <div className="additembox groupBordr">
                      <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                          {getSupplierId?.MasterGHGId
                            ? `(${
                                sortedData.find(
                                  (item) =>
                                    item.id === getSupplierId.MasterGHGId
                                )?.key
                              })`
                            : "Select GHG"}
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          style={{
                            maxHeight: "250px",
                            overflowY: "auto",
                          }}
                        >
                          {sortedData?.map((ghg) => (
                            <OverlayTrigger
                              key={ghg?.id}
                              placement="top"
                              overlay={
                                <Tooltip
                                  id={`tooltip-${ghg?.id}`}
                                  style={{ fontSize: "18px" }}
                                >
                                  {ghg?.value}
                                </Tooltip>
                              }
                            >
                              <Dropdown.Item
                                as="button"
                                style={{ height: "100%" }}
                                onClick={() => {
                                  setSupplierId((prevData) => ({
                                    ...prevData,
                                    MasterGHGId: ghg.id,
                                  }));
                                  setDefaultGHG(ghg.id);
                                  setGhgData(JSON.stringify(ghg)); // if required
                                }}
                                active={getSupplierId?.MasterGHGId === ghg?.id} // Highlights the selected item
                              >
                                {`(${ghg?.key})`}
                              </Dropdown.Item>
                            </OverlayTrigger>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>

                      <input
                        type="text"
                        className="form-control"
                        style={{ backgroundColor: "#fff" }}
                        placeholder={t("add") + " " + t("GHG Key")}
                        Add
                        value={GHGDes}
                        readOnly
                      />
                    </div>
                  </div>
                  {/* <div className="suppDividr mb-4">
                  </div> */}
                  <span className="cricleGreen">{t("currency")}</span>
                  <select
                    className="form-control"
                    style={{ margin: "10px 0" }}
                    name="currencyType"
                    onChange={(e) => {
                      setSupplierId((prevData) => ({
                        ...prevData,
                        currencyType: e.target.value,
                      }));
                    }}
                  >
                    <option value="">{t("Select")}</option>
                    {currencyData.length !== 0 &&
                      currencyData?.map((currencyRow, index) => (
                        <option
                          value={currencyRow?.name}
                          selected={
                            getSupplierId?.currencyType === currencyRow?.name
                          }
                        >
                          {currencyRow?.name}
                        </option>
                      ))}
                  </select>
                  {/* <p className="pb-3">
                    <span className="spanBtn">
                      {getSupplierId?.currencyType}
                    </span>
                  </p> */}
                  <div style={{ display: "flex" }}>
                    <span className="cricleGreen">
                      {t("invoice_eis_company")}
                    </span>
                    <div className="toggle-container">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={getSupplierId?.esProvider}
                          onChange={(e) => {
                            setSupplierId((prevData) => ({
                              ...prevData,
                              esProvider: !getSupplierId?.esProvider,
                            }));
                          }}
                        />
                        {getSupplierId?.esProvider ? (
                          <span className="slider round"></span>
                        ) : (
                          <span className="slideroff round"></span>
                        )}
                      </label>
                      <p style={{ marginBottom: "3px" }}>
                        {getSupplierId?.esProvider ? "Yes" : "No"}
                      </p>
                    </div>
                  </div>
                  &nbsp;
                  {/* {getSupplierId?.esProvider == true ? (
                    <span>YES</span>
                  ) : (
                    <span>NO</span>
                  )} */}
                  <br></br>
                  <Button
                    variant="success"
                    style={{ marginTop: "10px" }}
                    onClick={handleUpdate}
                  >
                    {t("update")}
                  </Button>
                </Tab>
                <Tab eventKey="Products" title={t("products")}>
                  <Modal
                    size="lg"
                    show={showModal}
                    onHide={() => setShowModal(false)}
                  >
                    <Modal.Header closeButton className="import_product_header">
                      {" "}
                      {t("Upload Product")}
                    </Modal.Header>
                    <form onSubmit={IMPORT_SUPPLIER}>
                      <Modal.Body>
                        <div className="w-full lg:w-12/12 pr-4 mb-10 font-light">
                          <label
                            className="label-category-bottom-text"
                            htmlFor="categoryBottomText"
                          >
                            {t("file")}
                          </label>
                          <label htmlFor="dropzone-file" className="dropzone">
                            <div className="dropzone-content">
                              {icon && (
                                <img
                                  src={icon}
                                  className="dropzone-icon"
                                  alt="..."
                                />
                              )}
                              <svg
                                aria-hidden="true"
                                className="dropzone-svg"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path>
                              </svg>
                              <p className="dropzone-text">
                                <span className="dropzone-text-bold">
                                  {t("click_to_upload")}
                                </span>{" "}
                                {t("or_drag_and_drop")}
                              </p>
                              <p className="dropzone-file-type">
                                {t("file_type")}
                              </p>
                            </div>
                            <input
                              id="dropzone-file"
                              type="file"
                              className="dropzone-input"
                              onChange={handleChange}
                            />
                          </label>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="danger" onClick={onClose}>
                          {t("close")}
                        </Button>
                        <Button variant="success">
                          <CSVLink
                            data={[]}
                            headers={sampleDocumentData}
                            filename="Sample Document.csv"
                            style={{ color: "white" }}
                          >
                            {" "}
                            {t("sample_document")}
                          </CSVLink>
                        </Button>
                        <Button variant="success" type="submit">
                          {t("save")}
                        </Button>
                      </Modal.Footer>
                    </form>
                  </Modal>
                  <div className="dbtableTop">
                    <div className="swtch">
                      {/* <div className="toggle-container">
                        <label className="switch">
                          <input
                            type="checkbox"
                            checked={isToggleddata}
                            onChange={handleToggledata}
                          />
                          <span className="slider round"></span>
                        </label>
                        <p>{isToggleddata ? "With Co2e" : "Without Co2e"}</p>
                      </div> */}
                    </div>

                    <div className="dbtableSrchbg">
                      <select className="form-control mr-0" onChange={onMonth}>
                        <option selected={month == ""} value="">
                          {t("Select Month")}
                        </option>
                        <option>1</option>
                        <option>3</option>
                        <option>6</option>
                        <option>9</option>
                        <option>12</option>
                      </select>
                      &nbsp;
                      {selected.length !== 0 && (
                        <button
                          className="commonButton"
                          onClick={(e) => onUnspc(e)}
                        >
                          <i className="fa-solid fa-plus"></i> {t("add")} UNSPSC
                        </button>
                      )}
                      &nbsp;
                      {selected.length !== 0 && (
                        <button
                          className="commonButton"
                          onClick={(e) => onBaseUnit(e)}
                        >
                          <i className="fa-solid fa-plus"></i> {t("add")} Base Unit
                          Information
                        </button>
                      )}
                      &nbsp;
                      {selectedCO2.length !== 0 && (
                        <button
                          className="commonButton"
                          onClick={() => setCO2Modal(true)}
                        >
                          <i className="fa-solid fa-plus"></i> {t("add")}{" "}
                          {t("CO2 Information")}
                        </button>
                      )}
                      &nbsp;
                      <button className="commonButton">
                        <Link to={`/addproduct?${supplierId}`}>
                          <i className="fa-solid fa-plus"></i> {t("Add Product")}
                        </Link>
                      </button>
                      &nbsp;
                      <button
                        Productbutton
                        className="commonButton"
                        onClick={OPEN_MODAL}
                      >
                        {t("Upload Product")}
                      </button>
                      {/* {getSupplierId?.email === userEmail && (
                        <button className="commonButton">
                          <Link to={`/addproduct?${supplierId}`}>
                            <i className="fa-solid fa-plus"></i> Add Product
                          </Link>
                        </button>
                      )} */}
                      &nbsp;
                      <button className="commonButton" onClick={_RESET}>
                        {t("reset")}
                      </button>
                    </div>
                  </div>

                  <>
                    <Tabs
                      defaultActiveKey="tab6"
                      id="my-tabs"
                      className="supplyerTablink"
                    >
                      <Tab
                        eventKey="tab6"
                        title={t("General Product Information")}
                      >
                        <div className="dbMaintable">
                          <Button variant="success">
                            <CSVLink
                              data={generalTableData}
                              headers={generalProductColumn}
                              filename="General Product Information.csv"
                              style={{ color: "white" }}
                            >
                              {" "}
                              {t("export_to_excel")}
                            </CSVLink>
                          </Button>

                          <table>
                            <thead>
                              <tr>
                                {generalProductColumn.map((col) => (
                                  <th>{col.label}</th>
                                ))}
                                <th>{t("Purchase History")}</th>
                                <th>{t("Logs")}</th>
                                {/* <th>Supplier name</th>
                            <th>Product Number</th>
                            <th>Product Name</th>
                            <th>
                              {!isToggleddata && (
                                <Checkbox
                                  name="all"
                                  value={
                                    selected.length ===
                                    getProductId.filter((item) => !item.unspsc)
                                      .length
                                  }
                                  updateValue={selectAll}
                                >
                                </Checkbox>
                              )}
                            </th>
                            <th style={{ textAlign: "center" }}>UNSPSC</th>

                            <th>List Price</th>
                            <th>Discount</th>
                            <th>Purchase Price</th>
                            <th>Quantity of Base unit</th>
                            <th>Purchase Price Base unit</th>
                            <th>KgCO2 of base unit</th>
                            <th>Last modified date</th> */}
                                <th>&nbsp;</th>
                                <th>&nbsp;</th>
                              </tr>
                            </thead>
                            {/* {!currentPageData.length && (
                          <SpinnerComponent
                            isLoading={!currentPageData.length}
                          />
                        )} */}
                            {isLoading && (
                              <SpinnerComponent isLoading={isLoading} />
                            )}
                            <tbody>
                              {generalTableData
                                ?.slice(offset, offset + PER_PAGE)
                                ?.map((d) => (
                                  <tr
                                    className={d?.isActive ? null : "inactive"}
                                  >
                                    <td>
                                      <Link
                                        to={`/supplierdetailsinfo?id=${d?.supplierId}`}
                                        style={{ color: "rgb(13, 110, 253)" }}
                                      >
                                        {d?.supplierName}
                                      </Link>
                                    </td>
                                    <td>
                                      <Link to="javascript:void(0)">
                                        {d?.productNumber}
                                      </Link>
                                    </td>
                                    <td>
                                      <Link
                                        to={`/productdetails?id=${d?.id}`}
                                        style={{ color: "rgb(13, 110, 253)" }}
                                      >
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={
                                            <Tooltip
                                              id="tooltip"
                                              style={{ fontSize: "10px" }}
                                            >
                                              {d?.productName}
                                            </Tooltip>
                                          }
                                        >
                                          <span>
                                            {`${d?.productName?.slice(0, 10)}${
                                              d?.productName?.length > 10
                                                ? "..."
                                                : ""
                                            }`}
                                          </span>
                                        </OverlayTrigger>
                                      </Link>
                                    </td>
                                    {/* <td>
                                {!d.unspsc && (
                                  <Checkbox
                                    name={d}
                                    value={selected.some(
                                      (item) => item.id === d.id
                                    )}
                                    updateValue={handleSelect}
                                  ></Checkbox>
                                )}
                              </td> */}
                                    {d?.UNSPSC ? (
                                      <td
                                        className="text-center"
                                        style={{ fontSize: "16px" }}
                                        // onClick={e=>onUnspc(e,d)}
                                      >
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={
                                            <Tooltip
                                              id="tooltip"
                                              style={{ fontSize: "10px" }}
                                            >
                                              {d?.UNSPSC}
                                            </Tooltip>
                                          }
                                        >
                                          <Button
                                            variant="success"
                                            className="unspsc"
                                          >
                                            {`${(d?.UNSPSC).slice(0, 10)}${
                                              (d?.UNSPSC).length > 10
                                                ? "..."
                                                : ""
                                            }`}
                                          </Button>
                                        </OverlayTrigger>
                                      </td>
                                    ) : (
                                      <td
                                        className="text-center"
                                        style={{ fontSize: "16px" }}
                                      >
                                        ....
                                      </td>
                                    )}

                                    {/* <td>
                                <Link to="javascript:void(0)">
                                  {Number(
                                    Number(d?.purchasePrice).toFixed(2) /
                                      Number(d?.item?.InvoicedQuantity?._text)
                                  ).toFixed(2)}
                                </Link>
                              </td> */}
                                    <td>
                                      {d?.listPrice
                                        ? Number(d?.listPrice).toFixed(2)
                                        : "----"}
                                    </td>
                                    {/* <td>
                                <Link to="javascript:void(0)">
                                  {Number(d?.purchasePrice).toFixed(2)}
                                </Link>
                              </td> */}

                                    <td>
                                      <Link to="javascript:void(0)">
                                        {d?.discount ? d?.discount : "----"}%
                                      </Link>
                                    </td>
                                    <td>
                                      {d?.listPrice
                                        ? getPurchasePrice(
                                            d?.listPrice,
                                            d?.discount
                                          )
                                        : "----"}
                                    </td>

                                    {/* <td>
                                <Link to="javascript:void(0)">
                                  {d?.saleUnitQty ? d?.saleUnitQty : "----"}
                                </Link>
                              </td> */}
                                    <td>
                                      <Link to="javascript:void(0)">
                                        {d?.baseUnit ? d?.baseUnit : "----"}
                                      </Link>
                                    </td>
                                    <td>
                                      <Link to="javascript:void(0)">
                                        {d?.purchasePriceBase}
                                      </Link>
                                    </td>
                                    <td>
                                      <Link to="javascript:void(0)">
                                        {d?.kgco2_co2_unit
                                          ? d?.kgco2_co2_unit
                                          : "----"}
                                      </Link>
                                    </td>

                                    <td>{d?.productUpdatedAt}</td>
                                    <td data-label="Logs">
                                      <Link
                                        onClick={(e) => onPurchase(e, d?.id)}
                                      >
                                        <i className="fa-solid fa-clock"></i>
                                      </Link>
                                    </td>
                                    <td data-label="Logs">
                                      <Link onClick={(e) => onLogs(e, d?.id)}>
                                        <i
                                          className="fa fa-history"
                                          aria-hidden="true"
                                        ></i>
                                      </Link>
                                    </td>
                                    <td>
                                      <button
                                        onClick={() =>
                                          handleActive(d?.id, d?.isActive)
                                        }
                                        className="beye"
                                      >
                                        <i className="fa-light fa-eye"></i>
                                        <i className="fa-light fa-eye-slash"></i>
                                      </button>
                                      &nbsp;&nbsp;
                                      {/* <i className="fa-regular fa-trash"></i> */}
                                      {/* <i className="fa-light fa-eye-slash"></i> */}
                                    </td>
                                    <td>
                                      {" "}
                                      &nbsp;&nbsp;
                                      {/*  &nbsp;&nbsp;
                          <Link to="/">
                            <i className="fa-light fa-pen"></i>
                          </Link> */}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </Tab>

                      <Tab
                        eventKey="tab7"
                        title={t("Units and UNSPSC Information")}
                      >
                        <div className="dbMaintable">
                          <Button variant="success">
                            <CSVLink
                              data={UNSPSCAndCO2Data}
                              headers={UNSPSCAndCO2Header}
                              filename="Units and UNSPSC Information.csv"
                              style={{ color: "white" }}
                            >
                              {" "}
                              {t("export_to_excel")}
                            </CSVLink>
                          </Button>
                          <table>
                            <thead>
                              <tr>
                                <th>
                                  {!isToggleddata && (
                                    // <Checkbox
                                    //   name="all"
                                    //   value={
                                    //     selected.length ===
                                    //     getProductId.filter(
                                    //       (item) => !item.unspsc
                                    //     ).length
                                    //   }
                                    //   updateValue={selectAll}
                                    // >

                                    // </Checkbox>

                                    <input
                                      type="checkbox"
                                      checked={selectedAll}
                                      onChange={(e) => selectAll(e)}
                                    />
                                  )}
                                </th>
                                {UNSPSCColumn.map((col) => (
                                  <th>{col.label}</th>
                                ))}
                                <th>{t("Purchase History")}</th>
                                <th>{t("Logs")}</th>

                                <th>&nbsp;</th>
                                <th>&nbsp;</th>
                              </tr>
                            </thead>
                            {/* {isToggleddata} */}
                            {!currentPageData.length && (
                              <SpinnerComponent
                                isLoading={!currentPageData.length}
                              />
                            )}
                            {isLoading && (
                              <SpinnerComponent isLoading={isLoading} />
                            )}
                            <tbody>
                              {UNSPSCTableData?.slice(
                                offset,
                                offset + PER_PAGE
                              )?.map((d) => (
                                <tr className={d?.isActive ? null : "inactive"}>
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={selected.some(
                                        (item) => item.id == d.id
                                      )}
                                      onClick={() => onUNSPSCCheck(d)}
                                    />
                                  </td>
                                  <td>
                                    <Link
                                      to={`/supplierdetailsinfo?id=${d.supplierId}`}
                                      style={{ color: "rgb(13, 110, 253)" }}
                                    >
                                      {d?.supplierName}
                                    </Link>
                                  </td>
                                  <td>
                                    <Link to="javascript:void(0)">
                                      {d?.productNumber}
                                    </Link>
                                  </td>
                                  <td>
                                    <Link
                                      to={`/productdetails?id=${d?.id}`}
                                      style={{ color: "rgb(13, 110, 253)" }}
                                    >
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip
                                            id="tooltip"
                                            style={{ fontSize: "10px" }}
                                          >
                                            {d?.productName}
                                          </Tooltip>
                                        }
                                      >
                                        <span>
                                          {`${(d?.productName).slice(0, 10)}${
                                            (d?.productName).length > 10
                                              ? "..."
                                              : ""
                                          }`}
                                        </span>
                                      </OverlayTrigger>
                                    </Link>
                                  </td>

                                  <td>
                                    {d?.sale_unit_of_measure
                                      ? d?.sale_unit_of_measure
                                      : "----"}
                                  </td>
                                  {/* <td>
                                {d?.salePrice
                                  ? Number(d?.salePrice).toFixed(2)
                                  : "----"}
                              </td> */}
                                  <td>
                                    {d?.base_unit_of_measure
                                      ? d?.base_unit_of_measure
                                      : "----"}
                                  </td>
                                  <td>{d?.baseUnit ? d?.baseUnit : "----"}</td>
                                  <td>
                                    {d?.sub_unit_of_measure
                                      ? d?.sub_unit_of_measure
                                      : "----"}
                                  </td>
                                  <td>
                                    {d?.subUnitQty ? d?.subUnitQty : "----"}
                                  </td>

                                  {d?.UNSPSC ? (
                                    <td
                                      className="text-center"
                                      style={{ fontSize: "16px" }}
                                      onClick={(e) => onUnspc(e, d)}
                                    >
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip
                                            id="tooltip"
                                            style={{ fontSize: "10px" }}
                                          >
                                            {d?.UNSPSC}
                                          </Tooltip>
                                        }
                                      >
                                        <Button
                                          variant="success"
                                          className="unspsc"
                                        >
                                          {`${(d?.UNSPSC).slice(0, 10)}${
                                            (d?.UNSPSC).length > 10 ? "..." : ""
                                          }`}
                                        </Button>
                                      </OverlayTrigger>
                                    </td>
                                  ) : (
                                    <td
                                      className="text-center"
                                      style={{ fontSize: "16px" }}
                                    >
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={(e) => onUnspc(e, d)}
                                      >
                                        <i className="fa-regular fa-circle-plus"></i>
                                      </Link>
                                    </td>
                                  )}
                                  <td data-label="Logs">
                                    <Link onClick={(e) => onPurchase(e, d?.id)}>
                                      <i className="fa-solid fa-clock"></i>
                                    </Link>
                                  </td>
                                  <td data-label="Logs">
                                    <Link onClick={(e) => onLogs(e, d?.id)}>
                                      <i
                                        className="fa fa-history"
                                        aria-hidden="true"
                                      ></i>
                                    </Link>
                                  </td>

                                  <td>
                                    <button
                                      onClick={() =>
                                        handleActive(d?.id, d?.isActive)
                                      }
                                      className="beye"
                                    >
                                      <i className="fa-light fa-eye"></i>
                                      <i className="fa-light fa-eye-slash"></i>
                                    </button>
                                    &nbsp;&nbsp;
                                    {/* <i className="fa-regular fa-trash"></i> */}
                                    <i className="fa-light fa-eye-slash"></i>
                                  </td>
                                  <td>
                                    {" "}
                                    &nbsp;&nbsp;
                                    {/*  &nbsp;&nbsp;
                          <Link to="/">
                            <i className="fa-light fa-pen"></i>
                          </Link> */}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </Tab>

                      <Tab eventKey="tab8" title={t("CO2 Information")}>
                        <div className="dbMaintable">
                          <Button variant="success">
                            <CSVLink
                              data={UNSPSCAndCO2Data}
                              headers={UNSPSCAndCO2Header}
                              filename="Units and UNSPSC Information.csv"
                              style={{ color: "white" }}
                            >
                              {" "}
                              {t("export_to_excel")}
                            </CSVLink>
                          </Button>
                          <table>
                            <thead>
                              <tr>
                                <th>
                                  <input
                                    type="checkbox"
                                    checked={selectedCO2All}
                                    onChange={(e) => onCO2CheckAll(e)}
                                  />
                                </th>
                                {CO2Column.map((col) => (
                                  <th>{col.label}</th>
                                ))}
                                <th>{t("Purchase History")}</th>
                                <th>{t("Logs")}</th>
                                {/* <th>Supplier name</th>
                            <th>Product Number</th>
                            <th>Product Name</th>
                            <th>CO2e unit of measure</th>
                            <th> KgCO2 in base unit quantity</th>

                            <th> Manufacturer name</th>
                            <th> Manufacturer product number</th>
                            <th> Country of Origin</th> */}

                                <th>&nbsp;</th>
                                <th>&nbsp;</th>
                              </tr>
                            </thead>
                            {/* {isToggleddata} */}
                            {!currentPageData.length && (
                              <SpinnerComponent
                                isLoading={!currentPageData.length}
                              />
                            )}
                            {isLoading && (
                              <SpinnerComponent isLoading={isLoading} />
                            )}
                            <tbody>
                              {CO2TableData?.slice(
                                offset,
                                offset + PER_PAGE
                              )?.map((d) => (
                                <tr className={d?.isActive ? null : "inactive"}>
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={selectedCO2.includes(d?.id)}
                                      onChange={() => onCO2Check(d?.id)}
                                    />
                                  </td>
                                  <td>{d?.id}</td>
                                  <td>
                                    <Link
                                      to={`/supplierdetailsinfo?id=${d.supplierId}`}
                                      style={{ color: "rgb(13, 110, 253)" }}
                                    >
                                      {d?.supplierName}
                                    </Link>
                                  </td>
                                  <td>
                                    <Link to="javascript:void(0)">
                                      {d?.productNumber}
                                    </Link>
                                  </td>
                                  <td>
                                    <Link
                                      to={`/productdetails?id=${d?.id}`}
                                      style={{ color: "rgb(13, 110, 253)" }}
                                    >
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip
                                            id="tooltip"
                                            style={{ fontSize: "10px" }}
                                          >
                                            {d?.productName}
                                          </Tooltip>
                                        }
                                      >
                                        <span>
                                          {`${d?.productName?.slice(0, 10)}${
                                            d?.productName?.length > 10
                                              ? "..."
                                              : ""
                                          }`}
                                        </span>
                                      </OverlayTrigger>
                                    </Link>
                                  </td>

                                  <td>
                                    {d?.co2_unt_measure
                                      ? d?.co2_unt_measure
                                      : "----"}
                                  </td>
                                  <td>{d?.co2_qty ? d?.co2_qty : "----"}</td>

                                  <td>
                                    {d?.kgco2_co2_unit
                                      ? d?.kgco2_co2_unit
                                      : "----"}
                                  </td>
                                  <td>
                                    {d?.KgCO2_per_Sale_unit
                                      ? d?.KgCO2_per_Sale_unit
                                      : "----"}
                                  </td>

                                  <td>
                                    {d?.manufactureName
                                      ? d?.manufactureName
                                      : "----"}
                                  </td>
                                  <td>
                                    {d?.manufactureProductNumber
                                      ? d?.manufactureProductNumber
                                      : "----"}
                                  </td>
                                  <td>
                                    <select
                                      className="countryDropdown"
                                      onChange={(e) =>
                                        handleCountry(e.target.value, d?.id)
                                      }
                                    >
                                      <option value="">Country</option>
                                      {countryData?.map((data) => (
                                        <option
                                          value={data?.isoCode}
                                          selected={
                                            d?.country === data?.isoCode
                                          }
                                        >
                                          {data?.name}
                                        </option>
                                      ))}
                                    </select>
                                  </td>

                                  {/* <td>{"1"}</td>
    
                              <td>{"----"}</td>
                              <td>

                                {d?.productUpdatedAt}

                              </td> */}
                                  <td data-label="Logs">
                                    <Link onClick={(e) => onPurchase(e, d?.id)}>
                                      <i className="fa-solid fa-clock"></i>
                                    </Link>
                                  </td>
                                  <td data-label="Logs">
                                    <Link onClick={(e) => onLogs(e, d?.id)}>
                                      <i
                                        className="fa fa-history"
                                        aria-hidden="true"
                                      ></i>
                                    </Link>
                                  </td>
                                  {/* <td
                                    className="text-center"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={(e) => onCo2(e, d)}
                                    >
                                      <i className="fa-regular fa-circle-plus"></i>
                                    </Link>
                                  </td> */}
                                  <td>
                                    <button
                                      onClick={() =>
                                        handleActive(d?.id, d?.isActive)
                                      }
                                      className="beye"
                                    >
                                      <i className="fa-light fa-eye"></i>
                                      <i className="fa-light fa-eye-slash"></i>
                                    </button>
                                    &nbsp;&nbsp;
                                    {/* <i className="fa-regular fa-trash"></i> */}
                                    {/* <i className="fa-light fa-eye-slash"></i> */}
                                  </td>
                                  <td>
                                    {" "}
                                    &nbsp;&nbsp;
                                    {/*  &nbsp;&nbsp;
                          <Link to="/">
                            <i className="fa-light fa-pen"></i>
                          </Link> */}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </Tab>
                    </Tabs>

                    {!isLoading && (
                      <ReactPaginate
                        previousLabel={t("previous")}
                        nextLabel={t("next")}
                        pageCount={pageCount}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination"}
                        previousLinkClassName={"pagination__link"}
                        nextLinkClassName={"pagination__link"}
                        disabledClassName={"pagination__link--disabled"}
                        activeClassName={"pagination__link--active"}
                        forcePage={currentPage}
                      />
                    )}
                  </>
                </Tab>

                <Tab eventKey="Invoices" title={t("Invoices")}>
                  <div className="dbtableTop">
                    &nbsp;
                    <div className="dbtableSrchbg">
                      <div className="dateSelect">
                        <DatePicker
                          selectsStart
                          selected={startDate}
                          onChange={onFromDate}
                          // startDate={startDate}
                          placeholderText={t("from")}
                          dateFormat="yyyy-MM-dd"
                        />
                        &nbsp;&nbsp;
                        <DatePicker
                          selectsEnd
                          selected={endDate}
                          onChange={onToDate}
                          endDate={endDate}
                          startDate={startDate}
                          minDate={startDate}
                          placeholderText={t("to")}
                          dateFormat="yyyy-MM-dd"
                        />
                      </div>
                      &nbsp;
                      {/* <select
                        className="form-control mr-0"
                        onChange={onBusinessUnit}
                      >
                        <option selected={businessUnit.length==0} value=''>
                          All Business unit
                        </option>
                        {invoiceBusinessDataList.map((d) => (
                          <option value={Number(d?.id)}>
                            {d?.name}
                          </option>
                        ))}
                      </select>&nbsp; */}
                      <button className="commonButton" onClick={_RESET}>
                        {t("reset")}
                      </button>
                    </div>
                  </div>

                  <div className="dbMaintable respTable">
                    <table>
                      <thead>
                        <tr>
                          <th>{t("invoiceId")}</th>
                          <th>{t("date")}</th>
                          <th>{t("businessUnit")}</th>
                          <th>{t("totalAmount")}</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>

                      <tbody>
                        {getSupplierInvoiceId?.map((d) => (
                          <tr>
                            <td
                              data-label="Invoice Id"
                              style={{ color: "rgb(13, 110, 253)" }}
                            >
                              <Link
                                style={{ color: "rgb(13, 110, 253)" }}
                                to={`/invoicedetails?id=${d?.invoiceId}`}
                              >
                                {d?.Invoice?.invoice.Invoice?.ID?._text}
                              </Link>
                            </td>
                            <td data-label="Date">
                              {d?.Invoice?.invoice?.Invoice?.IssueDate?._text}
                            </td>
                            <td data-label="Business unit">
                              {
                                "----"
                                // d?.Invoice?.invoice?.Invoice?.AccountingCustomerParty
                                //   ?.Party?.PartyName?.Name?._text
                              }
                            </td>
                            <td data-label="Total Amount">
                              {
                                d?.Invoice?.invoice?.Invoice?.LegalMonetaryTotal
                                  ?.TaxInclusiveAmount?._attributes?.currencyID
                              }{" "}
                              {
                                d?.Invoice?.invoice?.Invoice?.LegalMonetaryTotal
                                  ?.TaxInclusiveAmount?._text
                              }
                            </td>
                            <td data-label="Action">
                              <button className="beye">
                                <i className="fa-light fa-eye"></i>
                                <i className="fa-light fa-eye-slash"></i>
                              </button>
                              &nbsp;&nbsp;
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Tab>

                <Tab eventKey="Orders" title={t("orders")}>
                  <div className="dbtableTop">
                    &nbsp;
                    <div className="dbtableSrchbg">
                      <div className="dateSelect">
                        <DatePicker
                          selectsStart
                          selected={OrderstartDate}
                          onChange={onOrderFromDate}
                          // startDate={startDate}
                          placeholderText={t("from")}
                          dateFormat="yyyy-MM-dd"
                        />
                        &nbsp;&nbsp;
                        <DatePicker
                          selectsEnd
                          selected={OrderendDate}
                          onChange={onOrderToDate}
                          endDate={OrderendDate}
                          startDate={OrderstartDate}
                          minDate={OrderstartDate}
                          placeholderText={t("to")}
                          dateFormat="yyyy-MM-dd"
                        />
                      </div>
                      &nbsp;
                      <select
                        className="form-control mr-0"
                        onChange={onOrderBusinessUnit}
                      >
                        <option selected={businessUnit.length === 0} value="">
                          {t("All Business unit")}
                        </option>
                        {invoiceBusinessDataList.map((d) => (
                          <option value={Number(d?.id)}>{d?.name}</option>
                        ))}
                      </select>
                      &nbsp;
                      <button className="commonButton" onClick={_RESET}>
                        {t("reset")}
                      </button>
                    </div>
                  </div>

                  <div className="dbMaintable respTable">
                    <table>
                      <thead>
                        <tr>
                          <th>{t("orderId")}</th>
                          <th>{t("invoiceId")}</th>
                          <th>{t("businessUnitName")}</th>
                          <th>{t("dateOfGeneration")}</th>
                          <th>{t("totalAmount")}</th>
                        </tr>
                      </thead>

                      <tbody>
                        {getSupplierOrderId?.map((d) => (
                          <tr>
                            <td data-label="Order Id">
                              <Link
                                to={`/pastorderdetail?id=${d?.id}&invoiceId=${d?.invoiceId}`}
                                style={{ color: "rgb(13, 110, 253)" }}
                              >
                                {d?.id}
                              </Link>
                            </td>
                            <td data-label="Invoice Id">
                              <Link
                                to={`/invoicedetails?id=${d?.orginalInvoiceId}`}
                                style={{ color: "rgb(13, 110, 253)" }}
                              >
                                {d?.filterInvoiceId}
                              </Link>
                            </td>
                            <td data-label="Business unit name">
                              <Link
                                to={`/businessunitdetl?id=${d?.Department?.BusinessUnit?.id}`}
                                style={{
                                  color: d?.Department?.BusinessUnit?.id
                                    ? "rgb(13, 110, 253)"
                                    : "",
                                }}
                              >
                                {d?.Department?.BusinessUnit?.name}
                              </Link>
                            </td>
                            <td data-label="Date of generation">
                              {addOneDayToDate(d?.createdAt).toLocaleDateString(
                                "en-us",
                                { weekday: "long" }
                              )}
                              ,{" "}
                              {format(
                                addOneDayToDate(d?.createdAt),
                                "MM-dd-yyyy"
                              )}
                            </td>
                            <td data-label="Total">{d?.totalAmount}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Tab>

                <Tab eventKey="Performance" title={t("Performance")}>
                  <div className="dbMaintable suppdetlTable performanceTable respTable">
                    <table>
                      <thead>
                        <tr>
                          <th>{t("supplierName")}</th>
                          <th>{t("totalOrders")}</th>
                          <th>{t("q1")}</th>
                          <th>{t("q2")}</th>
                          <th>{t("q3")}</th>
                          <th>{t("q4")}</th>
                          <th>{t("q5")}</th>
                          <th>{t("total")}</th>
                          <th>{t("totalPerOrder")}</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td data-label="Name of the supplier">
                            <Link to="/supplierdetails">John Doe</Link>
                          </td>
                          <td data-label="Total Orders">20</td>
                          <td data-label="Q1">3</td>
                          <td data-label="Q2">0</td>
                          <td data-label="Q3">10</td>
                          <td data-label="Q4">8</td>
                          <td data-label="Q5">1</td>
                          <td data-label="Total">22</td>
                          <td data-label="Total / Total Orders">22/20</td>
                        </tr>
                        <tr>
                          <td data-label="Name of the supplier">
                            <Link to="/supplierdetails">John Doe</Link>
                          </td>
                          <td data-label="Total Orders">20</td>
                          <td data-label="Q1">3</td>
                          <td data-label="Q2">0</td>
                          <td data-label="Q3">10</td>
                          <td data-label="Q4">8</td>
                          <td data-label="Q5">1</td>
                          <td data-label="Total">22</td>
                          <td data-label="Total / Total Orders">22/20</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
      <Modal size="lg" show={showUnspc} onHide={handleCloseUnspc} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="mb-0">{t("add")} UNSPSC</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="dbMaintable productMainScroll">
            {search && <>Total results: {searchResults.length}</>}

            <div className="searchParentDiv">
              <div>
                <input
                  className="productSearch py-2 px-4"
                  type="search"
                  placeholder="Type something to search..."
                  onChange={(e) => searchUnspsc(e.target.value)}
                />
              </div>
              {search && (
                <div className="searchResults">
                  {searchResults && searchResults.length > 0 ? (
                    <>
                      {searchResults.map((result, index) => (
                        <div
                          className="form-check d-flex justify-content-between"
                          key={index}
                          onClick={() => getUnspscData(result)}
                        >
                          <div>
                            {index +
                              1 +
                              ". " +
                              result.value +
                              " (" +
                              result.belongsTo +
                              " " +
                              result.key +
                              ")"}
                          </div>
                          <div>
                            <i
                              className="fa fa-plus theme-color"
                              aria-hidden="true"
                              title="Click to Add"
                            ></i>
                          </div>
                        </div>
                      ))}

                      {totalSearchResult > searchResults.length && (
                        <div className="load-more d-flex justify-content-center">
                          {isSearchLoading ? (
                            <button disabled>
                              <i className="fa-solid fa-spinner fa-spin"></i>{" "}
                            </button>
                          ) : (
                            !searchResultsEnd && (
                              <button onClick={loadMoreResults}>
                                Load More
                              </button>
                            )
                          )}
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="form-check" style={{ textAlign: "center" }}>
                      {isSearchLoading ? (
                        <i className="fa-solid fa-spinner fa-spin"></i>
                      ) : (
                        "No Result Found"
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>

            <h2 className="d-flex justify-content-center">{t("OR")}</h2>

            <h5 className="mt-4 mb-3">UNSPSC :</h5>
            <div className="accordion unspscAccord" id="unAccordion">
              <div className="accordion-item">
                {segmentDataList
                  .sort((a, b) => a?.Segment - b?.Segment)
                  ?.map((segment) => (
                    <TreeItem
                      key={segment.Segment}
                      title={t("segment_code", {
                        segment: segment.Segment,
                        title: segment.SegmentTitle,
                      })}
                      isOpen={openSegment === segment.Segment}
                      toggleOpen={() => handleSegmentClick(segment.Segment)}
                      onClick={onDataSegment.bind(
                        segment?.Segment,
                        `${segment?.Segment}`
                      )}
                    >
                      {allUnspcFamily?.map((family) => (
                        <TreeItem
                          key={family.Family}
                          title={t("family_code", {
                            family: family.Family,
                            title: family.FamilyTitle,
                          })}
                          isOpen={openFamily === family.Family}
                          toggleOpen={() =>
                            handleFamilyClick(segment.Segment, family.Family)
                          }
                          onClick={onDataFamily.bind(
                            family?.Family,
                            `${family?.Family}`
                          )}
                        >
                          {allUnspcClass?.map((classItem) => (
                            <TreeItem
                              key={classItem.Class}
                              title={t("class_code", {
                                class: classItem.Class,
                                title: classItem.ClassTitle,
                              })}
                              isOpen={openClass === classItem.Class}
                              toggleOpen={() =>
                                handleClassClick(family.Family, classItem.Class)
                              }
                              onClick={onDataClass.bind(
                                classItem?.Class,
                                `${classItem?.Class}`
                              )}
                            >
                              {allUnspcComodity?.map((commodity) => (
                                <TreeItem
                                  key={commodity.Commodity}
                                  title={t("commodity_code", {
                                    commodity: commodity.Commodity,
                                    title: commodity.CommodityTitle,
                                  })}
                                />
                              ))}
                            </TreeItem>
                          ))}
                        </TreeItem>
                      ))}
                    </TreeItem>
                  ))}
              </div>
            </div>
          </div>

          <div className="d-flex">
            <button className="commonButton ms-auto p-2" onClick={searchPage}>
              {t("View More")}
            </button>
          </div>
        </Modal.Body>

        {/* <Modal.Body>
          <div className="dbMaintable productMainScroll">
            <Select
              options={searchOptions}
              placeholder={`${search} UNSPSC...`}
              noOptionsMessage={() => "Type something UNSPSC specific"}
              onChange={_SELECT_UNSPSC}
              onInputChange={_SEARCH_UNSPSC}
              components={{
                DropdownIndicator: () => null,
                IndicatorSeparator: () => null,
              }}
            />
            <h2 className="d-flex justify-content-center">{t("OR")}</h2>

            <h5 className="mt-4 mb-3">UNSPSC :</h5>
            <div className="accordion unspscAccord" id="unAccordion">
              <div className="accordion-item">
                {segmentDataList
                  .sort((a, b) => a?.Segment - b?.Segment)
                  ?.map((segment) => (
                    <TreeItem
                      key={segment.Segment}
                      title={t("segment_code", {
                        segment: segment.Segment,
                        title: segment.SegmentTitle,
                      })}
                      isOpen={openSegment === segment.Segment}
                      toggleOpen={() => handleSegmentClick(segment.Segment)}
                      onClick={onDataSegment.bind(
                        segment?.Segment,
                        `${segment?.Segment}`
                      )}
                    >
                      {allUnspcFamily?.map((family) => (
                        <TreeItem
                          key={family.Family}
                          title={t("family_code", {
                            family: family.Family,
                            title: family.FamilyTitle,
                          })}
                          isOpen={openFamily === family.Family}
                          toggleOpen={() =>
                            handleFamilyClick(segment.Segment, family.Family)
                          }
                          onClick={onDataFamily.bind(
                            family?.Family,
                            `${family?.Family}`
                          )}
                        >
                          {allUnspcClass?.map((classItem) => (
                            <TreeItem
                              key={classItem.Class}
                              title={t("class_code", {
                                class: classItem.Class,
                                title: classItem.ClassTitle,
                              })}
                              isOpen={openClass === classItem.Class}
                              toggleOpen={() =>
                                handleClassClick(family.Family, classItem.Class)
                              }
                              onClick={onDataClass.bind(
                                classItem?.Class,
                                `${classItem?.Class}`
                              )}
                            >
                              {allUnspcComodity?.map((commodity) => (
                                <TreeItem
                                  key={commodity.Commodity}
                                  title={t("commodity_code", {
                                    commodity: commodity.Commodity,
                                    title: commodity.CommodityTitle,
                                  })}
                                />
                              ))}
                            </TreeItem>
                          ))}
                        </TreeItem>
                      ))}
                    </TreeItem>
                  ))}
              </div>
            </div>
          </div>

          <div className="d-flex">
            <button className="commonButton ms-auto p-2" onClick={searchPage}>
              {t("View More")}
            </button>
          </div>
        </Modal.Body> */}
      </Modal>
    </div>
  );
};

export default Supplierdetailsinfo;
